import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import { AdminSidebar } from '@/components/AdminSidebar';
import AppBreadcrumb from '@/components/AppBreadcrumb';
import { Topbar, MainContent } from '@/components/Layout/styled';
import UserViewContextProvider from '@/components/Layout/UserViewContext';
import AdminChatUI from './AdminChatUI';

const AdminLayout = () => {
    return (
        <SidebarProvider>
            <UserViewContextProvider>
                <div className="flex h-screen w-full" data-print-root="true">
                    <AdminSidebar />
                    <main className="flex flex-col flex-1 overflow-hidden">
                        <Topbar data-print-hide="true">
                            <SidebarTrigger />
                            <Separator orientation="vertical" className="!h-6" />
                            <AppBreadcrumb />
                            <div className="ml-auto flex items-center gap-2">
                                <AdminChatUI />
                            </div>
                        </Topbar>
                        <MainContent data-print-content="true">
                            <Outlet />
                        </MainContent>
                    </main>
                </div>
            </UserViewContextProvider>
        </SidebarProvider>
    );
};

export default AdminLayout;
